import {
  InnerBlocks,
  useBlockProps,
  useInnerBlocksProps,
} from '@wordpress/block-editor';

export default function save({ attributes }) {
  const blockProps = useBlockProps.save({ className: 'bites-wrap' });

  const { addAsBlockStyles, flexClass, metadata } = attributes;

  // set innerBlockProps classes
  const { children, ...innerBlocksProps } = useInnerBlocksProps.save({
    className: `bf_layout ${flexClass}`,
  });

  return (
    <div {...blockProps}>
      {metadata && (
        <h4 className="bf_text-2xl bf_my-8 bf_block bf_text-bold">
          {metadata.name}
        </h4>
      )}
      <div {...innerBlocksProps}>{children}</div>
    </div>
  );
}
